// Copyright 2025, University of Maryland, All Rights Reserved
import type { ReactNode } from 'react'

interface SectionHeaderProps {
  icon: ReactNode
  title: string
  description?: ReactNode
  actions?: ReactNode
  className?: string
}

export const SectionHeader = ({ icon, title, description, actions, className }: SectionHeaderProps) => {
  return (
    <div className={`flex flex-col gap-2 ${className ?? ''}`.trim()}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className="inline-flex h-5 w-5 items-center justify-center text-primary">{icon}</span>
          <h3 className="text-lg font-semibold">{title}</h3>
        </div>
        {actions}
      </div>
      {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
    </div>
  )
}
